export const CARDS = [
  {
    pathname: "info-services/find-taxpayer",
    label: "Поиск налогоплательщика",
  },
  {
    pathname: "info-services/find-nds-payer",
    label: "Поиск данных о плательщике НДС",
  },
  {
    pathname: "info-services/unreliable-taxpayer",
    label: "Поиск неблагонадежных налогоплательщиков",
  },
  {
    pathname: "info-services/find-from-foreign-source",
    label: "Поиск сведений о лицах-получателях денег и (или) иного имущества из иностранных источников",
  },
  {
    pathname: "info-services/document-confirming-residence",
    label: "Поиск документа, подтверждающего резидентство РК",
  },
  {
    pathname: "info-services/find-liquidated-taxpayer",
    label: "Поиск налогоплательщиков, находящихся на стадии ликвидации",
  },
  {
    pathname: "info-services/find-debt",
    label: "Cведения об отсутствии (наличии) налоговой задолженности",
  },
  {
    pathname: "info-services/find-admin",
    label:
      "Единый реестр лиц, уведомления которых включены в реестр уведомлений лиц, имеющих право осуществлять деятельность администратора",
  },
  {
    pathname: "info-services/check-ukm",
    label: "Проверка достоверности учетно-контрольной марки на алкогольную продукцию",
  },
  {
    pathname: "info-services/risk-degree",
    label: "Степень риска налогоплательщика по результатам категорирования",
  },
  {
    pathname: "info-services/false-deals",
    label:
      "Поиск НП, сделки (операции) с которыми совершены без фактического выполнения работ, оказания услуг, отгрузки товаров",
  },
  {
    pathname: "info-services/register-creditors",
    label: "Реестр требований кредиторов в процедурах реабилитации и банкротства",
  },
  {
    pathname: "info-services/find-debtor",
    label:
      "Список должников, в отношении которых вступили в законную силу решения суда о признании банкротом или применении реабилитационной процедуры",
  },
];

export const TAXPAYER_TYPES = [
  { 
    code: "FL", 
    ru: "Физическое лицо", 
    kk: "Жеке тұлға", 
    en: "Individual", 
    qq: "Jeke tulǵa" 
  },
  {
    code: "IP",
    ru: "Индивидуальный предприниматель",
    kk: "Жеке кәсіпкер",
    en: "Individual entrepreneur",
    qq: "Jeke kásipker"
  },
  { 
    code: "UL", 
    ru: "Юридическое лицо",
    kk: "Заңды тұлға", 
    en: "Legal entity", 
    qq: "Zańdy tulǵa" 
  },
  {
    code: "LZCHP",
    ru: "Лицо, занимающееся частной практикой",
    kk: "Жеке практикамен айналысатын адам",
    en: "A person engaged in private practice",
    qq: "Jeke praktıkamen aınalysatyn adam"
  },
];

export const STATUSES = [
  { 
    code: "ALL", 
    ru: "Все",
    kk: "Барлығы",
    en: "All",
    qq: "Barlyǵy"
  },
  {
    code: "OPERATING", 
    ru: "Действующие",
    kk: "Қызмет етуші",
    en: "Active",
    qq: "Qyzmet etýshi"
  },
  {
    code: "SUSPENDED",
    ru: "Приостановившие деятельность",
    kk: "Қызметін тоқтатқан",
    en: "Suspended activities",
    qq: "Qyzmetin toqtatqan"
  },
];

export const CASE_TYPE = [
  { code: "BANKRUPTCY", value: 'register-creditors-bankruptcy' },
  { code: "REHABILITATION", value: 'register-creditors-rehabilitation' },
  { code: "LIQUIDATION", value: 'register-creditors-liquidation-of-debtor-short' },
];

export const TAX_ORG = [
  {
    code: "0101",
    ru: "Комитет государственных доходов Министерства финансов Республики Казахстан",
  },
  {
    code: "0301",
    ru: "ДГД по Акмолинской области",
  },
  {
    code: "0601",
    ru: "ДГД по Актюбинской области",
  },
  {
    code: "0901",
    ru: "ДГД по Алматинской области",
  },
  {
    code: "1501",
    ru: "ДГД по Атырауской области",
  },
  {
    code: "1801",
    ru: "ДГД по Восточно-Казахстанской области",
  },
  {
    code: "2101",
    ru: "ДГД по Жамбылской области",
  },
  {
    code: "2701",
    ru: "ДГД по Западно-Казахстанской области",
  },
  {
    code: "3001",
    ru: "ДГД по Карагандинской области",
  },
  {
    code: "3301",
    ru: "ДГД по Кызылординской области",
  },
  {
    code: "3901",
    ru: "ДГД по Костанайской области",
  },
  {
    code: "4301",
    ru: "ДГД по Мангистауской области",
  },
  {
    code: "4501",
    ru: "ДГД по Павлодарской области",
  },
  {
    code: "4801",
    ru: "ДГД по Северо-Казахстанской области",
  },
  {
    code: "5801",
    ru: "ДГД по Туркестанской области",
  },
  {
    code: "5901",
    ru: "ДГД по городу Шымкент",
  },
  {
    code: "6001",
    ru: "ДГД по г. Алматы",
  },
  {
    code: "6201",
    ru: "ДГД по г. Астана",
  },
];

export const lettersOnlyPattern = /^[a-zA-Zа-яА-ЯёЁ\sÄäÁáĞğǴǵÑñŃńÖöÓóŞşİiÜüŪūÚúӘәҒғӨөҰұҮүҚқҺһІі]+$/;

export const userAgreementText = '<p style="font-size: 18px">Общие положения</p>' +
    '<p>Настоящее Пользовательское соглашение (далее - Соглашение) регламентирует взаимоотношения между Владельцем, Администратором и Пользователем Портала Комитета государственных доходов Министерства финансов Республики Казахстан (далее &ndash; КГД МФ РК) и его компонентов.</p>' +
    '<p>В настоящем Соглашении используются следующие понятия:</p>' +
    '<p>1) Портал Комитета государственных доходов Министерства финансов Республики Казахстан (далее &ndash; Портал КГД) - информационная система, представляющая собой единое окно доступа ко всей консолидированной информации КГД, включая нормативную правовую базу, и к электронным сервисам;</p>' +
    '<p>2) компоненты Портала &ndash; части Портала, специализированные на предоставлении отдельных электронных услуг, информации и (или) сервисов;</p>' +
    '<p>3) электронный сервис (далее - Сервис) - предоставление физическим и юридическим лицам информационных, налоговых услуг с применением информационных технологий;</p>' +
    '<p>4) владелец Портала и его компонентов (далее - Владелец) уполномоченный орган в сфере налогового и таможенного администрирования;</p>' +
    '<p>5) пользователь Портала и его компонентов (далее - Пользователь) - любое физическое или юридическое лицо, принявшее условия настоящего Соглашения, зарегистрированное на Портале и в его компонентах, пользующееся услугами Портала и его компонентов для получения необходимых ему электронных информационных ресурсов, информации или сервисов в рамках действующего законодательства Республики Казахстан;</p>' +
    '<p>6) администратор Портала и его компонентов (далее - Администратор) &ndash; ответственный сотрудник Владельца Портала;</p>' +
    '<p>7) короткое текстовое сообщение (далее &ndash; SMS-сообщение) &ndash; услуга, оказываемая оператором сотовой связи по приему и передаче информации посредством сети сотовой связи;</p>' +
    '<p>8) электронная цифровая подпись (далее &ndash; ЭЦП) - набор электронных цифровых символов, созданный средствами электронной цифровой подписи и подтверждающий достоверность электронного документа, его принадлежность и неизменность содержания;</p>' +
    '<p style="font-size: 18px;">Предмет Соглашения</p>' +
    '<p>Настоящее Пользовательское соглашение (далее &ndash; Соглашение) регулирует отношения по использованию Портала КГД в сети Интернет (далее &ndash; Сеть) между КГД МФ РК и физическим / юридическим лицом, (именуемым в дальнейшем &laquo;Пользователь&raquo;), надлежащим образом зарегистрировавшимся на Портале КГД и имеющим собственную ЭЦП, выданную Национальным удостоверяющим центром (далее - НУЦ).</p>' +
    '<p>Портал КГД - единая среда, включающая в себя информационные разделы, ресурсы и сервисы, предоставляемые КГД МФ РК с целью информирования граждан о деятельности КГД МФ РК, получения информационных рассылок и других служб, а также обеспечения доступа к иным государственным сервисам и услугам.</p>' +
    '<p>Услуги системы Портала предоставляются Пользователям, имеющим доступ к сети Интернет, ЭЦП, установленное программное обеспечение для работы с веб-интерфейсом (браузером, например Google Chrome) и NCALayer' +
    '<p>Настоящее Соглашение вступает в силу путем выражения Пользователем согласия с их условиями в форме нажатия Пользователем элемента управления Веб-интерфейсом &quot;Ознакомлен и принимаю&quot;, помещенным под текстом Соглашения на странице регистрации/авторизации.</p>' +
    '<p>Пользователь понимает и принимает, что он несет полную ответственность за всю информацию, переданную в базу данных Портала.</p>' +
    '<p>Пользователь обязуется не использовать систему Портала не по назначению, не использовать Портал и полученную на Портале информацию в целях терроризма, экстремизма, разжигания межнациональной розни и в иных запрещенных законодательством Республики Казахстан целях.</p>' +
    '<p>Пользователь соглашается не воспроизводить, не повторять и не копировать, не продавать и не перепродавать, а также не использовать для каких-либо коммерческих целей какие-либо части системы Портала. КГД МФ РК не несет никакой ответственности ни по каким договорам между Пользователем и третьими лицами.</p>' +
    '<p>КГД МФ РК не несет ответственности за любые прямые или непрямые убытки, произошедшие из-за использования либо невозможности использования системы Портала.</p>';
